import { useCallback, useEffect, useMemo } from 'react';

import { readLocalStorageData, saveLocalStorageData } from '@app/services/localStorage.service';
import { Dates } from '@app/shared/constants/Dates';
import { LocalStorageItems } from '@app/shared/constants/localStorageItems';
import { LanguageType } from '@interfaces/FW/interfaces';
import { useTranslation } from 'react-i18next';

let localLanguage = (readLocalStorageData(LocalStorageItems.language) as LanguageType) || 'ua';

export const useLanguage = (): {
	language: LanguageType;
	setLanguage: (locale: LanguageType) => Promise<void>;
} => {
	const { i18n } = useTranslation();

	const handleChangeLanguage = useCallback(
		async (locale: LanguageType) => {
			localLanguage = locale;
			Dates.setLocale(locale);
			saveLocalStorageData(LocalStorageItems.language, locale);
			await i18n.changeLanguage(locale);
		},
		[i18n],
	);

	useEffect(() => {
		localLanguage && handleChangeLanguage(localLanguage);
	}, [handleChangeLanguage]);

	return useMemo(
		() => ({
			language: i18n.language as LanguageType,
			setLanguage: handleChangeLanguage,
		}),
		[handleChangeLanguage, i18n.language],
	);
};
